import { render, staticRenderFns } from "./ImmatureNaming.vue?vue&type=template&id=526cae68"
import script from "./ImmatureNaming.vue?vue&type=script&setup=true&lang=js"
export * from "./ImmatureNaming.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports